import React from 'react';
import { Layout } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StylesFooter = styled.div`
  .epl-employee-list {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px 0px;
    text-align: center;
    background-color: var(--cl_white);
  }
`;

const { Footer } = Layout;

const Footers = () => {
  const { t } = useTranslation(['footer']);
  return (
    <StylesFooter>
      <Footer className="epl-employee-list">
        <div>{t('footer:app_name')}</div>
        <div>
          {t('footer:version', {
            version: process.env.REACT_APP_BUILD_VERSION,
            build: process.env.REACT_APP_BUILD_BUILD,
          })}
        </div>
      </Footer>
    </StylesFooter>
  );
};

export default Footers;
